<template>
  <div>
    <div
      id="carouselExampleIndicators"
      class="carousel slide d-none d-sm-none d-md-block"
      data-interval="4000"
    >
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img class="d-block diloconnieve" :src="image_web" alt="#DiloConNieve">
        </div>
      </div>
    </div>

    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="image_mobile"
      ></BannerTopMobile>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      image_mobile: `${process.env.VUE_APP_URL_FILES}/images/diloconnieve/diloconnieve.jpg`,
      image_web: `${process.env.VUE_APP_URL_FILES}/images/diloconnieve/diloconnieve.jpg`
    }
  }
}
</script>

<style scoped>
.carousel-item .diloconnieve {
  width: 100%;
}
@media only screen and (min-width: 2507px) and (max-width: 3500px) {
  .carousel-item .diloconnieve {
    height: 100vh !important;
  }
}
@media only screen and (min-width: 2001px) and (max-width: 2506px) {
  .carousel-item .diloconnieve {
    height: 110vh !important;
  }
}
/*
@media only screen and (min-width: 1500px) and (max-width: 2500px) {
  .carousel-item .diloconnieve {
    height: 110vh !important;
  }
}
@media only screen and (min-width: 1350px) and (max-width: 1440px) {
  .carousel-item .diloconnieve {
    height: 85vh !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1349px) {
  .carousel-item .diloconnieve {
    height: 72vh !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1023px) {
  .carousel-item .diloconnieve {
    height: 70vh !important;
  }
}*/
</style>
